import * as Actions from '../actions';

const initialState = {
    role: [],//guest
    data: {
        'displayName': 'Администратор',
        'photoURL'   : 'assets/images/avatars/profile.jpg',
        'email'      : 'admin@babyclub.ru',
        shortcuts    : [
            'calendar',
            'mail',
            'contacts',
            'todo'
        ],
        divisions: [],
        isAdmin: false,
        uid: '00000000-0000-0000-0000-000000000000',
    }
};

const user = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.SET_USER_DATA:
        {
            return {
                ...initialState,
                ...action.payload
            };
        }
        case Actions.REMOVE_USER_DATA:
        {
            return {
                ...initialState
            };
        }
        case Actions.USER_LOGGED_OUT:
        {
            return initialState;
        }
        default:
        {
            return state
        }
    }
};

export default user;
